<button class="back-to-signin-btn" (click)="logout()" nz-button>
  <img src="/assets/icons/sign-out-icon.svg" alt="Sign out">
  {{ 'buttons.back-to-signin' | translate }}
</button>